// HorseForm.js
import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { useForm, FormProvider } from "react-hook-form";
import FormInput from "../../components/atoms/Input/Form-Input";
import CustomDatePicker from "../../components/atoms/Input/CustomDatePicker";
import { formatDisplayDate, formatString } from "../../utils";

const HorseForm = forwardRef(({
  title = "Update Horse",
  onSubmit,
  selectedHorse,
  loading = false,
}, ref) => {
  const methods = useForm({
    defaultValues: {
      horseName: "",
      email: "",
    },
  });
  
  const { handleSubmit, setValue } = methods;
  const [dob, setDob] = useState("");
  const [dobError, setDobError] = useState("");

  useEffect(() => {
    if (title === "Update Horse") {
      setValue("horseName", formatString(selectedHorse?.name));
      const initialDob = formatDisplayDate(selectedHorse?.dob);
      setDob(initialDob);
    }
  }, [selectedHorse, setValue, title]);

  const handleDobChange = (date) => {
    setDob(date);
    if (!date) {
      setDobError("Date of birth is required");
    } else {
      setDobError("");
    }
  };

  const onFormSubmit = (formData) => {
    if (title === "Update Horse" && !dob) {
      setDobError("Date of birth is required");
      return;
    }
    if (title === "Update Horse") {
      formData.date = dob;
      formData.id = selectedHorse?.id;
    } else if (title === "Update Horse Ownership") {
      formData.id = selectedHorse?.id;
    }
    onSubmit(formData);
  };

  useImperativeHandle(ref, () => ({
    submit: handleSubmit(onFormSubmit)
  }));

  const renderFormContent = () => {
    if (title === "Update Horse Ownership") {
      return (
        <div className="w-[90%] mx-auto p-4 mb-4">
          <FormInput
            name="email"
            label="Email"
            type="text"
            placeholder="Enter Email"
            className="w-full"
            validateOnChange={false}
            validations={{
              required: true,
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: "Invalid email address",
              },
            }}
          />
        </div>
      );
    } else if (title === "Update Horse") {
      return (
        <div className="w-[90%] mx-auto p-4">
          <div className="mb-4">
            <CustomDatePicker
              yearOnly
              clearable={!loading}
              name="date"
              value={dob}
              disabled={loading}
              {...(!loading && { onChange: handleDobChange })}
              label="Date of Birth"
              placeholder="Select birth year"
              inputClassName="font-montserrat text-[14px] w-[90%] md:w-[375px] px-3 sm:px-5 h-[50px] mt-2 rounded-[50px] border border-[#999]"
              className="w-full"
              error={dobError}
            />
          </div>
          <div className="mb-4">
            <FormInput
              name="horseName"
              label="Horse Name"
              type="text"
              disabled={loading}
              placeholder="Enter Horse Name"
              className="w-full"
              validations={{
                required: { value: true, message: "Horse name is required" },
              }}
            />
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        {renderFormContent()}
      </form>
    </FormProvider>
  );
});

export default HorseForm;
